import React from 'react';
import PropTypes from 'prop-types';

const getDisplayName = (WrappedComponent) => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

const combineComponents = (...components) => {
  return components.reduce(
    (AccumulatedComponents, CurrentComponent) => {
      AccumulatedComponents.displayName = `combineComponents(${getDisplayName(
        CurrentComponent
      )})`;
      // eslint-disable-next-line react/prop-types
      return ({ children }) => {
        return (
          <AccumulatedComponents>
            <CurrentComponent>{children}</CurrentComponent>
          </AccumulatedComponents>
        );
      };
    },
    ({ children }) => <>{children}</>
  );
};

combineComponents.propTypes = {
  children: PropTypes.node.isRequired
};

export default combineComponents;
